// Generated by ReScript, PLEASE EDIT WITH CARE


var firstNameLabel = "First Name";

var lastNameLabel = "Last Name";

var callerTypeLabel = "Caller Type";

var primMobileLabel = "Caller Primary Mobile";

var secMobileLabel = "Caller Secondary Mobile";

var addSecNumberBtnText = "Add Secondary Number";

var otpText = "Enter the Code that we sent to ";

var optNotReceivedText = "Did't recieve OTP?";

var companyNameLabel = "Company Name";

var porterGoldStatusLabel = "Porter Gold Status";

var geoRegionLabel = "Geo Region";

var emailTitle = "Confirmed Email:";

var emailLabel = "Email";

var verifyEmailBtnTxt = "Verify Email";

var unverifiedEmailLabel = "Unverified email pending!";

var gstinLabel = "GSTIN";

var gstRegAddressLabel = "GST Reg Address";

var cashbackSlabLabel = "Cashback Slab";

var cashbackOfferedLabel = "Cashback Offered";

var cashbackRedeemedLabel = "Cashback Redeemed";

var cashbackBalanceLabel = "Cashback Balance";

var customerTypeLabel = "Customer Type";

var temporarilyDeactivatedLabel = "Temporarily deactivated";

var registrationStatusLabel = "Registration Status";

var partloadCustomerLabel = "PartLoad Customer";

var subForPromoSMSLabel = "Subscribed for Promo SMS";

var confirmSubmitText = "Confirm Submit?";

export {
  firstNameLabel ,
  lastNameLabel ,
  callerTypeLabel ,
  primMobileLabel ,
  secMobileLabel ,
  addSecNumberBtnText ,
  otpText ,
  optNotReceivedText ,
  companyNameLabel ,
  porterGoldStatusLabel ,
  geoRegionLabel ,
  emailTitle ,
  emailLabel ,
  verifyEmailBtnTxt ,
  unverifiedEmailLabel ,
  gstinLabel ,
  gstRegAddressLabel ,
  cashbackSlabLabel ,
  cashbackOfferedLabel ,
  cashbackRedeemedLabel ,
  cashbackBalanceLabel ,
  customerTypeLabel ,
  temporarilyDeactivatedLabel ,
  registrationStatusLabel ,
  partloadCustomerLabel ,
  subForPromoSMSLabel ,
  confirmSubmitText ,
  
}
/* No side effect */
